import { render } from "./selectInventoryType.vue?vue&type=template&id=748356a4"
import script from "./selectInventoryType.vue?vue&type=script&lang=js"
export * from "./selectInventoryType.vue?vue&type=script&lang=js"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__